module.exports = __webpack_public_path__ + "static/media/1010279.42ee46f5.jpg";